import { render, staticRenderFns } from "./ReferenceTip.vue?vue&type=template&id=3ea79186&scoped=true"
import script from "./ReferenceTip.vue?vue&type=script&lang=js"
export * from "./ReferenceTip.vue?vue&type=script&lang=js"
import style0 from "./ReferenceTip.vue?vue&type=style&index=0&id=3ea79186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea79186",
  null
  
)

export default component.exports